import { useSelector } from 'react-redux';
import { selectAuthState } from '../store/auth/auth.selectors';

/**
 * Neurolytics user ids (the `nl_user_id` app_metadata claim, exposed on the
 * token as `https://neurolytics.ai/id`) that are allowed to use the Motiview
 * features in the dashboard without being a super admin.
 *
 * Motiview is otherwise super-admin only. Add an id here to give a specific
 * company admin the same Motiview surface: the "Motiview groups" nav item,
 * the Motiview group creation wizard, the Motiview settings tab and the
 * Motiview details CSV download.
 */
export const MOTIVIEW_ALLOWED_USER_IDS: string[] = [
    '02a3a5b9-db18-40ec-b504-97034db51bf8',
    '0643d2fc-802c-4f56-84a5-9f5a9fda2a52',
];

export const isMotiviewAllowedUserId = (userId?: string): boolean =>
    !!userId && MOTIVIEW_ALLOWED_USER_IDS.includes(userId);

/**
 * Whether the logged in user may see/use the Motiview features.
 *
 * Super admins always may; other users only when their id is allowlisted
 * above. Callers pass their already-derived `isSuperAdmin` flag so the role
 * derivation stays in one place (`WithAuthLayout`).
 */
export const useHasMotiviewAccess = (isSuperAdmin: boolean): boolean => {
    const { user } = useSelector(selectAuthState);

    return isSuperAdmin || isMotiviewAllowedUserId(user?.id);
};

export default useHasMotiviewAccess;
